import {RECOVER_PASSWORD, RECOVER_EMAIL, RECOVER_CODE,IS_LOADING_RECOVER_CODE, RESET_PASSWORD} from '../actions/types'

const initialRegisterEmailState={
    email:'',
    success:'',
    recoverUser:{},
    isLoadingViewRecoverCode:true,
    errorType:'',
    code:'',
    model:''
    }
    
    export default function(state=initialRegisterEmailState, action){ //lo que se manda de personasAction en el dispatch es el action
        switch(action.type){
                                 
            case IS_LOADING_RECOVER_CODE:
                return {...state,isLoadingViewRecoverCode:true}  
            case RECOVER_EMAIL:                                       // lo configuramos como la respuesta del servidor, es decir la res desde
                return {...state,email:action.payload.email,isLoadingViewRecoverCode:false, errorType:action.payload.errorType, success:action.payload.success, model: action.payload.model}  
            case RECOVER_CODE:                                          // lo configuramos como la respuesta del servidor, es decir la res desde
                return {...state,success:action.payload.success, isLoadingViewRecoverCode:false, errorType:action.payload.errorType, code:action.payload.code, model: action.payload.model}   
            case RECOVER_PASSWORD:                                          // lo configuramos como la respuesta del servidor, es decir la res desde
            return {...state, success:action.payload.success, isLoadingViewRecoverCode:false, errorType:action.payload.errorType}  
                                                                                //personas controller
            case RESET_PASSWORD:
            return {...state, success:action.payload.success, errorType:action.payload.errorType}    
            default:
                return state
         
        }
    }